import React from 'react';
import PropTypes from 'prop-types';

import { Link } from '../Link';
import { classNames } from '../../utilities';

import { NotificationsCount } from './NotificationsCount';
import styles from './NotificationsLink.css';

export const NotificationsLink = ({ count, extraStyles, title, url }) => (
  <Link extraStyles={classNames(styles.notificationsLink, extraStyles)} url={url}>
    <span className="hide-text-absolute">{title}</span>
    <NotificationsCount count={count} />
  </Link>
);

NotificationsLink.propTypes = {
  count: PropTypes.number,
  /**
    Use this to pass styles from another component stylesheet into the
    component, e.g. `styles.extraComponentStyles`. **Please note:** we cannot
    guarantee the CSS order when compiling the bundles so we need to increase
    the specificity of the extra styles selectors using `:root` e.g.
    `:root .extra-component-styles` in the CSS file.
  */
  extraStyles: PropTypes.string,
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired
};

NotificationsLink.defaultProps = {
  count: 0,
  extraStyles: ''
};
